import { render, staticRenderFns } from "./ListTPAs.vue?vue&type=template&id=38e57ea3&"
import script from "./ListTPAs.vue?vue&type=script&lang=js&"
export * from "./ListTPAs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports